/** Great-circle distance and Live Mode distance formatting. */

const EARTH_RADIUS_M = 6_371_000
const WALKING_SPEED_MPS = 1.4

export function haversineMeters(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (deg: number) => (deg * Math.PI) / 180
  const dLat = toRad(lat2 - lat1)
  const dLng = toRad(lng2 - lng1)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2
  return EARTH_RADIUS_M * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

export function walkingMinutes(distanceM: number): number {
  if (!Number.isFinite(distanceM) || distanceM <= 0) return 0
  return Math.max(1, Math.round(distanceM / WALKING_SPEED_MPS / 60))
}

export function formatDistance(m: number): string {
  if (m < 1000) return `${Math.round(m)} m`
  return `${(m / 1000).toFixed(1)} km`
}

export function formatWalkEta(distanceM: number): string {
  const mins = walkingMinutes(distanceM)
  return mins === 1 ? '~1 min walk' : `~${mins} min walk`
}

export const DEFAULT_NEARBY_RADIUS_M = 200
